import { API_URL as baseApiUrl } from "@/config/env";

export const functionalAdminUrls = {
    getCustomersToRename : baseApiUrl + "Admin/GetCustomersToRename_pagination?",
    updateCustomerData: baseApiUrl + "Admin/UpdateCustomerRename?",
    getCustomerCount: baseApiUrl + "Admin/GetCustomersToRename_Pagination_Count?",

    getSKUSwitchSearch: baseApiUrl + "ProductGroup/GetSKUSwitchSearch?",
    getGroupScenario: baseApiUrl + "Admin/GetGroupOrScenarioDetails?",
    getSearchCustomerTrustLevel: baseApiUrl + "Admin/SearchCustomerTrustLevel",
    getCustomerGroupRefData: baseApiUrl + "Scenario/GetCustomerGroupReferenceData",
    searchCustomerTrustLevel: baseApiUrl + "Admin/SearchCustomerTrustLevel?",
    updateCustomerTrustLevel: baseApiUrl + "Admin/UpdateCustomerTrustLevel",
    updateGroupOrScenarioActivation: baseApiUrl + "Admin/UpdateGroupOrScenarioActivation?",
    listUpdateGroupOrScenario: baseApiUrl + "Admin/ListUpdateGroupOrScenario",
};